import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { AreaCodeActionTypes, AreaCodeActions } from "../../../actionTypes/master/areaCodeActionTypes";
import {
  createAreaCodeApi,
  editAreaCodeDataByIdApi,
  getAreaCodeDataByIdApi,
  getAreaCodeListApi,
  deleteAreaCodeApi
} from "../../requests/master/areaCodeRequests";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { getAreaCodeList, setAreaCodeDataById, setAreaCodeList, setAreaCodeListPageCount } from "../../../actions/master/areaCodeActions";


function* createAreaCodeHandler(action: AreaCodeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createAreaCodeApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getAreaCodeListHandler(action: AreaCodeActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getAreaCodeListApi, action.payload);


    if (data.status) {
      yield put(setAreaCodeList(data?.data?.rows));
      yield put(setAreaCodeListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getAreaCodeDataByIdHandler(action: AreaCodeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getAreaCodeDataByIdApi, action.payload);
    if (data.status) {
      yield put(setAreaCodeDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editAreaCodeDataByIdHandler(action: AreaCodeActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editAreaCodeDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getAreaCodeList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* deleteAreaCodeHandler(action: AreaCodeActionTypes) {
  try {
    yield startLoader("transparent");

    const { data } = yield call(deleteAreaCodeApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });

      // refresh area code list after delete
      yield put(getAreaCodeList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// area code sagas
export default function* areaCodeSaga() {
  yield takeLatest(AreaCodeActions.CREATE_AREA_CODE, createAreaCodeHandler);
  yield takeLatest(AreaCodeActions.GET_AREA_CODE_LIST, getAreaCodeListHandler);
  yield takeLatest(AreaCodeActions.GET_AREA_CODE_DATA_BY_ID, getAreaCodeDataByIdHandler);
  yield takeLatest(AreaCodeActions.EDIT_AREA_CODE_DATA_BY_ID, editAreaCodeDataByIdHandler);
  yield takeLatest(AreaCodeActions.DELETE_AREA_CODE, deleteAreaCodeHandler);
}
